import React from 'react';
import ReactDOM from 'react-dom';
import { Link, NavLink, Redirect, Route, Switch } from 'react-router-dom';

import { PlayCircleIcon, CloseIcon } from '@mssgme/icons';

import IntegrationList from '../IntegrationList';
import { useIntegrationsPage } from './useIntegrationsPage';

import styles from './styles.scss';

export default function IntegrationsPage({ children }) {
    const { t, routes, rootPath, match, i18n } = useIntegrationsPage();

    return (
        <div className={styles.root}>
            <div className={styles.content}>
                <h1 className={styles.heading}>{t('IntegrationsPage.heading')}</h1>
                <p className={styles.subHeading}>{t('IntegrationsPage.subHeading')}</p>
                <IntegrationList className={styles.integrations} integrations={routes} />
                {children}
            </div>
            <Switch>
                {routes.map((route) => (
                    <Route
                        key={route.type}
                        path={route.path}
                        render={(props) =>
                            ReactDOM.createPortal(
                                <div className={styles.modalContainer}>
                                    <div className={styles.modal}>
                                        <NavLink to={rootPath} className={styles.closeModalBtn}>
                                            <CloseIcon size={24} />
                                        </NavLink>
                                        <div className={styles.modalHeader}>
                                            <img src={route.logo} alt="route.type" className={styles.modalLogo} />
                                            <h2 className={styles.modalTitle}>
                                                {t('IntegrationsPage.modal.connect')} {route.label}
                                            </h2>
                                            <p className={styles.modalSubTitle}>
                                                {t('IntegrationsPage.modal.subHeading')}
                                            </p>
                                            <NavLink
                                                to={`${rootPath}/${route.type}/video`}
                                                className={styles.playButton}
                                            >
                                                <PlayCircleIcon className={styles.iconPlay} />
                                                {t('IntegrationsPage.modal.videoTutorial')}
                                            </NavLink>
                                        </div>
                                        <route.component {...props} />
                                    </div>
                                </div>,
                                document.body
                            )
                        }
                    />
                ))}
                <Redirect to={match.path} />
            </Switch>
            <Switch>
                {routes.map((route) => (
                    <Route
                        key={route.type + '_video'}
                        exact
                        path={route.path + '/video'}
                        render={() =>
                            ReactDOM.createPortal(
                                <div className={styles.videoModalContainer}>
                                    <div className={styles.videoModal}>
                                        <Link to={route.path} className={styles.closeVideoModalBtn}>
                                            <CloseIcon size={24} />
                                        </Link>
                                        <div className={styles.videoModalFrame}>
                                            <iframe
                                                src={
                                                    i18n.language === 'ru' ? route.tutorialSrc.ru : route.tutorialSrc.en
                                                }
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                        <h3 className={styles.videoModalTitle}>
                                            {t('IntegrationsPage.modal.connecting')} {route.label}
                                        </h3>
                                    </div>
                                </div>,
                                document.body
                            )
                        }
                    />
                ))}
            </Switch>
        </div>
    );
}
